import React from "react";
import { Box } from "@mui/material";
import moment from "moment";

const CalendarDateIcon = ({ date }) => {
    const formatted = moment(date);
    const monthLabel = formatted.format("MMM").toUpperCase();
    const dayLabel = formatted.format("DD");

    return (
        <Box
            sx={{
                width: 44,
                height: 44,
                borderRadius: 1.5,
                overflow: "hidden",
                border: 2,
                borderColor: "primary.main",
                textAlign: "center",
                bgcolor: "background.paper",
                boxShadow: 0,
            }}
            aria-hidden
        >
            <Box
                sx={{
                    bgcolor: "primary.main",
                    color: "common.white",
                    fontSize: "0.75rem",
                    fontWeight: 700,
                    letterSpacing: 1,
                }}
            >
                {monthLabel}
            </Box>
            <Box
                sx={{
                    color: "text.primary",
                    fontWeight: 700,
                    fontSize: "1rem",
                    lineHeight: 1,
                    py: 0.6,
                }}
            >
                {dayLabel}
            </Box>
        </Box>
    );
};

export default CalendarDateIcon;
